import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'María López',
    age: 34,
    location: 'Buenos Aires, Argentina',
    text: 'Siempre se me bajaban los bizcochuelos en el medio. Con los trucos de este libro, la última torta que hice para el cumple de mi hijo quedó altísima y súper esponjosa. ¡No lo podía creer!'
  }, {
    name: 'Carmen Rodríguez',
    age: 42,
    location: 'Ciudad de México, México',
    text: 'Las recetas son muy claras. Me encantó que no usa ingredientes raros. Hice la torta clásica de vainilla y mi familia no dejó ni las migas. Los bonos de glaseados son un éxito.'
  }, {
    name: 'Lucía Fernández',
    age: 28,
    location: 'Bogotá, Colombia',
    text: 'Nunca había horneado nada en mi vida. Seguí el paso a paso y mi primera torta salió perfecta. La tabla de conversiones me salvó la vida porque no tengo balanza.'
  }, {
    name: 'Ana García',
    age: 51,
    location: 'Madrid, España',
    text: "Llevo años haciendo repostería pero siempre fallaba en algo. Este libro me enseñó los 'por qué' detrás de cada paso. Ahora mis tortas quedan como de pastelería."
  }, {
    name: 'Patricia Morales',
    age: 37,
    location: 'Lima, Perú',
    text: 'Compré el recetario dudando, pero valió cada centavo. Los budines salados del bono son mi nueva cena rápida favorita. 100% recomendado.'
  }];
  return <section className="py-20 px-4 bg-[#FFF8F0]" data-id="element-140">
      <div className="max-w-6xl mx-auto" data-id="element-141">
        <div className="text-center mb-16" data-id="element-142">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3C1518] mb-4" data-id="element-143">
            Miles de personas están redescubriendo el placer de preparar tortas
            caseras que realmente funcionan.
          </h2>
          <p className="text-xl text-[#C2410C]" data-id="element-144">
            Y ahora vos también podés hacerlo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-145">
          {testimonials.map((t, i) => <div key={i} className={`bg-white p-8 rounded-2xl border border-[#E8D5C0] ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-146">
              <div className="flex gap-1 mb-4" data-id="element-147">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#F59E0B] text-[#F59E0B]" data-id="element-148" />)}
              </div>
              <p className="text-[#5C2D0E] italic mb-6 leading-relaxed" data-id="element-149">
                "{t.text}"
              </p>
              <div className="flex items-center gap-4" data-id="element-150">
                <div className="w-12 h-12 bg-[#EA580C] rounded-full flex items-center justify-center text-white font-bold text-xl" data-id="element-151">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-152">
                  <p className="text-[#3C1518] font-bold" data-id="element-153">
                    {t.name}, {t.age}
                  </p>
                  <p className="text-[#A8763E] text-sm" data-id="element-154">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}